import { QueryClient } from "@tanstack/react-query";
import { clearTreeLoadCache } from "@/components/tree/tree-load-cache";
import { useTreeNavigationStore } from "@/store/tree-navigation";
import { clearAccountStorage } from "./browser-storage";
import { clearStoredImagesCache } from "./stored-images-cache";

const clientStateResets = new Set<() => void>();

/**
 * Registers an in-memory store to reset on logout. Stores that only tree pages load (and that would pull the tree
 * renderer into every page) register themselves here instead of being imported by the app shell.
 */
export function resetOnClientCacheClear(reset: () => void) {
  clientStateResets.add(reset);
}

export function clearClientCache(queryClient: QueryClient) {
  queryClient.clear();
  clearTreeLoadCache();
  clientStateResets.forEach((reset) => reset());
  useTreeNavigationStore.setState({ histories: {} });
  clearAccountStorage();
  clearStoredImagesCache();
}
